<template>
    <component :is="layout">
        <router-view></router-view>
    </component>
</template>

<script>
const defaultLayout = "default";

export default {
    computed: {
        layout() {
            return (this.$route.meta.layout || defaultLayout) + "-layout";
        }
    },
    methods: {
        getNetwork(key) {
            return this.$store.state.vaults.env.network[key].chain;
        }
    },
    mounted() {},
    async created() {
        this.$store
            .dispatch("vaults/init", JSON.parse(window.VAULT_ENV))
            .then(async () => {
                await this.$store.dispatch("wallet/getNetworkAbi");
                await this.$store.dispatch("wallet/initEvent");
                await this.$store.dispatch("wallet/checkWalletStatus");
            });
    }
};
</script>
<style lang="scss">
@import "~../sass/app.scss";
@import "./resources/sass/_variables.scss";
</style>
